import React from "react";
import { rng } from "../../amorg-common";
import { Button } from "../button/Button";
import { colors } from "../colors/color";
import { TextInput } from "../inputs/TextInput";
import { Modal } from "../Modal";
import { P, Small } from "../typography/Body";
import { Flex } from "./FlexHelpers";

type DeleteConfirmationModalProps = {
    showModal:boolean,
    asIcon?: boolean,
    title?: string,
    confirmationHeading: string,
    confirmationText: string,
    requireKey: boolean,
    buttonText: string,
    onConfirmDelete: () => void,
    onCancel: () => void,
}
export function DeleteConfirmationModal(props:DeleteConfirmationModalProps):JSX.Element
{
    const [confirmationKey, setConfirmationKey] = React.useState('');
    const [confirmationInput, setConfirmationInput] = React.useState('');

    React.useEffect(()=>{
        setConfirmationKey(getConfirmationKey());
        setConfirmationInput('');
    }, [props.showModal])

    function getConfirmationKey() {
        return rng.getRandomCharacters(
            4,
            ['upper']
        )
    }

    function handleConfirmationInputChange(value: string) {
        setConfirmationInput(value);
    }

    return (
        
        <Modal
            title={props.confirmationHeading}
            showModal={props.showModal}
            onCancel={props.onCancel}
            content={
                <Flex gap={16} justifyContent={"center"} flexDirection="column" alignItems="center">
        
                <Flex justifyContent="center" gap={16}>
                    <P>{props.confirmationText}</P>
                </Flex>
        
                {props.requireKey &&
                <Flex flexDirection="column" gap={16}>
                    <Flex flexDirection="row" gap={8}>
                        <span style={{ padding: '10px', border: `1px solid ${colors.text.state.error}` }}>
                            <b>{confirmationKey}</b>
                        </span>
                        <TextInput
                            value={confirmationInput}
                            onChange={value => handleConfirmationInputChange(value.toUpperCase())}
                        />
                    </Flex>
                    <Flex justifyContent="center">
                        <Small>
                        Indtast koden for at bekræfte sletning
                        </Small>
                    </Flex>
                </Flex>
                }

                <Flex justifyContent="space-between" width="100%">
                    
                    <Button 
                        onClick={props.onCancel}
                        variant="text"
                        text={"Annuller"} />
                    <Button 
                        onClick={props.onConfirmDelete}
                        variant="destructive"
                        disabled={props.requireKey && confirmationInput !== confirmationKey}
                        icon={"interface_actions_delete"}
                        text={props.buttonText} />
                    
                </Flex>
            </Flex>        
            }
        />
    );
}